import i18n from "i18next";

export const imageSizeError = 11;

export const formatSizeError = 22;

export const imageNoError = 0;

export const kilobytesInMegabytes = 1024;

export const maxImageSizeInMegabytes = 1 * 1024 * 1024;

export const sexOptions = [
  i18n.t('components.select.male'),
  i18n.t('components.select.female')
];

export const mainColors = {
  yellow: "#F6D658"
}

export const fakeCourse = {
  max_users_count: 22,
  name: 'Nikita Boss',
  description: 'Nikittaaaa',
  avatar: 'https://cdn.euroweeklynews.com/wp-content/uploads/2022/09/russian-rapper-timati.jpg',
  deadline: 1685491200,
  start_date: 1693655726,
  program: {
    workouts: [{
      name: 'Тренировка №4',
      status: 3,
      deadline: 1685491200,
      start_date: 1693655726,
      program_video_link: 'www.bebra.com',
      sets: [{
        name: 'Сет 1', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      },
      {
        name: 'Отдых', time: 5
      },
      {
        name: 'Сет 2', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      }],
    },
    {
      name: 'Тренировка №3',
      status: 0,
      deadline: 1685491200,
      start_date: 1693655726,
      program_video_link: 'www.bebra.com',
      sets: [{
        name: 'Сет 1', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      },
      {
        name: 'Отдых', time: 5
      },
      {
        name: 'Сет 2', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      }],
    },
    {
      name: 'Тренировка №2',
      status: 1,
      deadline: 1685491200,
      start_date: 1693655726,
      program_video_link: 'www.bebra.com',
      sets: [{
        name: 'Сет 1', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      },
      {
        name: 'Отдых', time: 5
      },
      {
        name: 'Сет 2', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      }],
    },
    {
      name: 'Тренировка №1',
      status: 2,
      deadline: 1685491200,
      start_date: 1693655726,
      sets: [{
        name: 'Сет 1', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      },
      {
        name: 'Отдых', time: 5
      },
      {
        name: 'Сет 2', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      }],
    }]
  },
  id: 4,
  users_count: 16,
  invite_code: "FORA",
  publish: true,
  save_photos: false,
  credites: 931,
  author: { name: 'Timati', avatar_url: "https://cdn.euroweeklynews.com/wp-content/uploads/2022/09/russian-rapper-timati.jpg" },
  level: 0,
  workout_num: 2,
  workouts_count: 8,
  ranking: 2,
  status: 0,
  users: []
  // users: [
  //   {
  //     id: 1,
  //     name: "Вячеслав Иванов",
  //     level: 3.59,
  //     position: 4,
  //     previousPosition: 4
  //   },
  //   {
  //     id: 2,
  //     name: "Мария Петрова",
  //     level: 5.0,
  //     position: 1,
  //     previousPosition: 2
  //   },
  //   {
  //     id: 3,
  //     name: "Анна Васильева",
  //     level: 4.12,
  //     position: 2,
  //     previousPosition: 4
  //   },
  //   {
  //     id: 4,
  //     name: "Екатерина Иванова",
  //     level: 4.01,
  //     position: 3,
  //     previousPosition: 2
  //   },
  //   {
  //     id: 5,
  //     name: "Александра Володина",
  //     level: 3.25,
  //     position: 5,
  //     previousPosition: 8
  //   },
  //   {
  //     id: 6,
  //     name: "Ксения Александрова",
  //     level: 3.14,
  //     position: 7,
  //     previousPosition: 8
  //   },
  //   {
  //     id: 7,
  //     name: "Никита Шевчик",
  //     level: 4.14,
  //     position: 6,
  //     previousPosition: 10
  //   }
  // ]
}
export const fakeCourse2 = {
  max_users_count: 22,
  name: 'Никита Никита',
  description: 'Nikittaaaa',
  avatar: 'https://m.media-amazon.com/images/M/MV5BNGFhYjM1NjUtZmQyNC00OTlmLWI2ZTMtOWE4OWM4ZTdkN2VjXkEyXkFqcGdeQXVyNjMwOTA1MDM@._V1_.jpg',
  deadline: 1685491200,
  start_date: 1693655726,
  program: {
    workouts: [{
      name: 'Анжуманя',
      status: 3,
      deadline: 1685491200,
      start_date: 1693655726,
      program_video_link: 'www.bebra.com',
      sets: [{
        name: 'Сет 1', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      },
      {
        name: 'Отдых', time: 5
      },
      {
        name: 'Сет 2', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      }],
    },
    {
      name: 'Бегит',
      status: 0,
      deadline: 1685491200,
      start_date: 1693655726,
      program_video_link: 'www.bebra.com',
      sets: [{
        name: 'Сет 1', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      },
      {
        name: 'Отдых', time: 5
      },
      {
        name: 'Сет 2', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      }],
    },
    {
      name: 'Прэс',
      status: 1,
      deadline: 1685491200,
      start_date: 1693655726,
      program_video_link: 'www.bebra.com',
      sets: [{
        name: 'Сет 1', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      },
      {
        name: 'Отдых', time: 5
      },
      {
        name: 'Сет 2', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      }],
    },
    {
      name: 'Анжуманя опять',
      status: 2,
      deadline: 1685491200,
      start_date: 1693655726,
      sets: [{
        name: 'Сет 1', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      },
      {
        name: 'Отдых', time: 5
      },
      {
        name: 'Сет 2', exercises: [{
          type: 'Отжимания',
          label: 'Отжимания',
          value: 5,
          modificators: [],
        },
        {
          type: 'Приседания',
          label: 'Приседания',
          value: 15,
          modificators: [],
        },
        {
          type: 'Прыжки',
          label: 'Прыжки',
          value: 12,
          modificators: [],
        }]
      }],
    }]
  },
  id: 4,
  users_count: 16,
  invite_code: "FORA",
  publish: true,
  save_photos: false,
  credites: 931,
  author: { name: 'Slava Tery', avatar_url: "https://m.media-amazon.com/images/M/MV5BNGFhYjM1NjUtZmQyNC00OTlmLWI2ZTMtOWE4OWM4ZTdkN2VjXkEyXkFqcGdeQXVyNjMwOTA1MDM@._V1_.jpg" },
  level: 0,
  workout_num: 2,
  workouts_count: 8,
  ranking: 2,
  status: 0,
  users: [
    {
      id: 1,
      name: "Вячеслав Иванов",
      level: 3.59,
      position: 4,
      previousPosition: 4
    },
    {
      id: 2,
      name: "Мария Петрова",
      level: 5.0,
      position: 1,
      previousPosition: 2
    },
    {
      id: 3,
      name: "Анна Васильева",
      level: 4.12,
      position: 2,
      previousPosition: 4
    },
    {
      id: 4,
      name: "Екатерина Иванова",
      level: 4.01,
      position: 3,
      previousPosition: 2
    },
    {
      id: 5,
      name: "Александра Володина",
      level: 3.25,
      position: 5,
      previousPosition: 8
    },
    {
      id: 6,
      name: "Ксения Александрова",
      level: 3.14,
      position: 7,
      previousPosition: 8
    },
    {
      id: 7,
      name: "Никита Шевчик",
      level: 4.14,
      position: 6,
      previousPosition: 10
    }
  ]
}


export const fakeSimpleCourse = {
  id: 123,
  name: 'Nikita boss',
  workout_num: 8,
  workouts_count: 2,
  members: 24,
  status: 1,
  deadline: 1685491200,
  start_date: 1693655726,
  exercises_complete: 3
}
